import api from "./api";

export const getInfoFinanceiras = async () => {
  try {
    const info = await api.get(`/info-financeira`);
    return info.data;
  } catch (error) {
    throw error;
  }
};

export const cadastrarInfoFinanceiras = async (data) => {
  try {
    const info = await api.post(`/info-financeira`, data);
    return info.data;
  } catch (error) {
    throw error;
  }
};

export const editarInfoFinanceiras = async (id, data) => {
  try {
    const info = await api.put(`/info-financeira/${id}`, data);
    return info.data;
  } catch (error) {
    throw error;
  }
};

export const deletarInfoFinanceiras = async (id) => {
  try {
    const info = await api.delete(`/info-financeira/${id}`);
    return info.data;
  } catch (error) {
    throw error;
  }
};

export const getInfoFinanceiraEstabelecimento = async (estabelecimentoId) => {
  try {
    const info = await api.get(`/info-financeira/estabelecimento/${estabelecimentoId}`);
    return info.data[0];
  } catch (error) {
    throw error;
  }
};
